import DashboardApi from "./DashboardApi";

export default DashboardApi;
